export default __webpack_public_path__ + "media/zurb/img/events/wired/family-giving/family-giving-photos-464bdd904fbac952085dec712caadb88.png";